// See https://invis.io/MFCX32YQJ#/246970701_Style_Guide_-_Colours

// Primary UI colours
export const brandBl: string = '#4f73af'
export const brandBls: string = '#11195A'
export const brandOrg: string = '#F07662'
export const white: string = '#fff'

// Tonal UI colours
export const basicBlDark: string = '#31374f'
export const basicBlMain: string = '#555a77'
export const mainStroke: string = '#cfd8dd'
export const qabBg: string = '#f0f3f5'
export const bg2: string = '#f4f7fa'

// UI accent colours
export const error: string = '#f25858'
export const warning: string = '#faa532'
export const success: string = '#42a57c'

// Shadows
export const shadow: string = '#31374e'



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/styles/colours.ts